module.exports = __webpack_public_path__ + "static/img/details.6f6f05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/details.png
// module id = jaVq
// module chunks = 1 3